module.exports = __webpack_public_path__ + "static/media/logo.b6e00d6e.svg";